import { render, staticRenderFns } from "./AgendaItemFacets.vue?vue&type=template&id=d3e6fdc2"
import script from "./AgendaItemFacets.vue?vue&type=script&lang=js"
export * from "./AgendaItemFacets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports